export const timeConstants = {
  defaultUrgent: 60000,
  defaultExpiring: 300000,
  basketAllocationUrgent: 600000,
  basketAllocationExpiring: 900000,
  fundAssignmentUrgent: 600000,
  fundAssignmentExpiring: 900000
}
